import React, { useState } from 'react';

import { TEXTS } from 'application/pages/texts';
import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import styles from './index.module.scss';

export type CustomContentRemoveModalProps = {
  onSubmit: () => Promise<void>;
  onCancel: () => void;
};

const CustomContentRemoveModal = ({ onSubmit, onCancel }: CustomContentRemoveModalProps) => {
  const [isLoading, setIsloading] = useState(false);

  return (
    <ModalScreen
      title={TEXTS.CUSTOM_CONTENT_REMOVE_MODAL_TITLE}
      hideCloseButton
      onClose={onCancel}
      actionButtons={[
        <Button
          key="button_remove_custom_content_submit"
          elementId="button_remove_custom_content_submit"
          isLoading={isLoading}
          type={ButtonType.PRIMARY}
          onClick={async () => {
            setIsloading(true);
            await onSubmit();
            setIsloading(false);
          }}>
          {TEXTS.CUSTOM_CONTENT_REMOVE_MODAL_BUTTON_SUBMIT}
        </Button>,
        <Button
          key="button_remove_custom_content_cancel"
          elementId="button_remove_custom_content_cancel"
          isDisabled={isLoading}
          type={ButtonType.SECONDARY}
          onClick={onCancel}>
          {TEXTS.CUSTOM_CONTENT_REMOVE_MODAL_BUTTON_CANCEL}
        </Button>,
      ]}>
      <span className={styles.CustomContentRemoveModalDesc}>{TEXTS.CUSTOM_CONTENT_REMOVE_MODAL_DESC}</span>
    </ModalScreen>
  );
};

export default CustomContentRemoveModal;
